import { REACT_APP__URL_EASYPOST_BASE } from "@smp/utils";
import { apiRequest } from "../../../../lib";
export class ApiEpBillingTokenPackage {
}
ApiEpBillingTokenPackage.list = (req) => apiRequest({
    endpoint: `${REACT_APP__URL_EASYPOST_BASE}api/v1/billing/product/token/`,
    method: "GET",
    query: req === null || req === void 0 ? void 0 : req.query,
});
ApiEpBillingTokenPackage.purchase = (req) => apiRequest({
    body: req.body,
    endpoint: `${REACT_APP__URL_EASYPOST_BASE}api/v1/billing/product/token/${req.path.id}/purchase`,
    method: "POST",
});
//# sourceMappingURL=token.js.map